module.exports = __webpack_public_path__ + "static/IMG_1254-65c1fbf6ef80a38a32d0f113e79e60df.jpg";